<template>
  <svg
    width="6"
    height="13"
    viewBox="0 0 6 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="0.5"
      width="6"
      height="12"
      rx="1"
      fill="#FFC531"
    />
    <rect
      y="0.5"
      width="6"
      height="12"
      rx="1"
      fill="white"
      fill-opacity="0.2"
    />
  </svg>
</template>
